import getYear from 'date-fns/get_year'
import { getField, updateField } from 'vuex-map-fields';

state =
    # the current left-most year
    year: getYear(new Date())

    # the current top-most index (row)
    topindex: 1

    # 2-states
    score_review: 1
    score_imdb: 1
    score_metacritic: 0
    time_review: 0
    time_release: 0
    time_collection: 0
    imdbyear: 0
    genre: 0
    runtime: 0
    index: 1
    group_by_year: 1

    # 3-states
    index_type: 0 # 0 = absolute, 1 = relative global, 2 = relative per year
    movies_or_series: 1 # 0 = only movies, 1 = both, 2 = only series
    layout: 0 # compact - normal - wide

getters = { getField }

mutations = {
    # mutations for the simple fields (like 'seen')
    updateField
    SET_YEAR: (state, year) ->
        min = 1900
        max = getYear(new Date())
        year = min if year < min
        year = max if year > max
        console.log "setting year to ", year
        state.year = year
    SET_TOPINDEX: (state, topindex) ->
        topindex = 1 if topindex < 1
        # console.log "setting top to ", topindex
        state.topindex = topindex
}

export default {
    namespaced: true
    state
    getters
    mutations
}
